import React from "react";
import {
  QueryCache,
  QueryClient,
  QueryClientProvider
} from "@tanstack/react-query";
import PropTypes from "prop-types";
import { NotificationsLevel } from "../lib/enums";
import { show } from "../notifications/notifications";
import { CANCEL_ERROR } from "../requests";

const TWENTY_MIN = 1000 * 60 * 20;
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: "always",
      retry: false,
      staleTime: TWENTY_MIN
    }
  },
  // recommended way of handling on demand error messages according to
  // https://tkdodo.eu/blog/breaking-react-querys-api-on-purpose#defining-on-demand-messages
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (error.problem === CANCEL_ERROR) return;
      if (query?.meta?.errorMessage) {
        show({
          message: query.meta.errorMessage,
          level: NotificationsLevel.ERROR
        });
      }
    }
  })
});
const ReactQuery = ({ children }) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);
ReactQuery.propTypes = {
  children: PropTypes.node.isRequired
};
export default ReactQuery;
